import { render, staticRenderFns } from "./ProductsRowSection.vue?vue&type=template&id=7751c6f4&scoped=true&"
import script from "./ProductsRowSection.vue?vue&type=script&lang=js&"
export * from "./ProductsRowSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductsRowSection.vue?vue&type=style&index=0&id=7751c6f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7751c6f4",
  null
  
)

export default component.exports